import PropTypes from "prop-types";
import React from "react";

import { TextField } from "@mui/material";

const InputFormField = ({
  label = "",
  helperText = undefined,
  error = false,
  errorMessage = "",
  apiErrorMessage = "",
  noBorder = false,
  fullWidth = true,
  onBlur,
  InputProps = {},
  ...rest
}) => {
  const onInputBlur = (e) => {
    // Fix for ios virtual keyboard closing sometimes does not update position of fixed elements because Safari is the new Internet Explorer
    window.scrollBy(0, 0);
    // This is done to support dictation software
    if (e && e.target && e.target.value && e.target.value !== rest.value) {
      rest.onChange && rest.onChange(e);
    }
    onBlur && onBlur(e);
  };

  return (
    <TextField
      helperText={errorMessage || apiErrorMessage || helperText}
      variant={label ? "filled" : "outlined"}
      onBlur={onInputBlur}
      error={error || !!errorMessage || !!apiErrorMessage}
      label={label}
      InputProps={{
        ...InputProps,
        className: `${noBorder ? "no-border" : ""}`,
      }}
      FormHelperTextProps={{
        component: "div",
      }}
      fullWidth={fullWidth}
      {...rest}
    />
  );
};

InputFormField.propTypes = {
  label: PropTypes.string,
  helperText: PropTypes.node,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  apiErrorMessage: PropTypes.string,
  noBorder: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onBlur: PropTypes.func,
  InputProps: PropTypes.object,
};

export default InputFormField;
